<!-- Main Banner -->
<div class="main-banner">
    <div class="main-banner-item item-four">
        <div class="d-table">
            <div class="d-table-cell">
                <div class="container-fluid">
                    <div class="row align-items-center">
                        <div class="col-lg-6 col-md-12">
                            <div class="main-banner-content">
                                <h2 style="text-transform: none;">Our core business is to help customers achieve their
                                    business
                                    objectives by
                                    providing innovative, best-in-class IT
                                    consulting and solutions.</h2>
                                <p>Please follow our services and expertise to know more..</p>
                                <div class="option-item">
                                    <a routerLink="/contact-us" class="default-btn">Get Started</a>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-12">
                            <div class="main-banner-image">
                                <img src="assets/img/banner/banner-image-4.jpg" alt="image">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End Main Banner -->

<!-- Features -->
<section class="features-area pt-100 pb-70" id="features">
    <div class="container">
        <div class="section-title text-width">
            <span>Our services</span>
            <h2>Find out our key services</h2>
            <div class="bar"></div>
        </div>

        <div class="row align-items-center">
            <div class="col-lg-6 col-md-12">
                <div class="features-image-warp">
                    <img src="assets/img/features/features-2.png" alt="image">
                </div>
            </div>

            <div class="col-lg-6 col-md-12">
                <div class="row">
                    <div class="col-lg-6 col-md-6">
                        <div class="single-features-box top-1">
                            <div class="icon">
                                <i class="flaticon-promotion"></i>
                            </div>
                            <h3><a routerLink="/testing-services">Testing Services</a></h3>
                            <p>Varios testing tools we use for testing to make your product more relieble and robust</p>
                        </div>
                    </div>

                    <div class="col-lg-6 col-md-6">
                        <div class="single-features-box top-2">
                            <div class="icon">
                                <i class="flaticon-speed"></i>
                            </div>
                            <h3><a routerLink="/development-services">Development Services</a></h3>
                            <p>Our devlopment team to fully capable to develope desktop, web and mobile applications</p>
                        </div>
                    </div>

                    <div class="col-lg-6 col-md-6">
                        <div class="single-features-box top-3">
                            <div class="icon">
                                <i class="flaticon-email"></i>
                            </div>
                            <h3><a routerLink="/resource-management-services">Resource Management Services</a></h3>
                            <p>We provide various range of resource management servoces which will help you to grow
                                faster</p>
                        </div>
                    </div>

                    <div class="col-lg-6 col-md-6">
                        <div class="single-features-box top-4">
                            <div class="icon">
                                <i class="flaticon-network"></i>
                            </div>
                            <h3><a routerLink="/data-analytics-services">Data and Analytics</a></h3>
                            <p>Our team is expert on performing data related services and reports</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Features -->

<!-- About -->
<section class="about-area pb-100">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-6 col-md-12">
                <div class="about-image-warp image-three">
                    <a href="https://www.youtube.com/watch?v=ODfy2YIKS1M" class="video-btn popup-youtube">
                        <i class='bx bx-play'></i>
                    </a>
                </div>
            </div>

            <div class="col-lg-6 col-md-12">
                <div class="about-content warp">
                    <span>About Us</span>
                    <div class="bar"></div>
                    <p>Digital Transformation is on everyone’s lips, but many businesses don’t know where to start as it
                        looks complicated and
                        almost impossible to conceptualism. Our Digital Advisory team enables organizations to
                        accelerate and deliver a digital
                        transformational journey built on deep customer knowledge and many years of experience.

                        We have skilled digital technology experts that cover industry, technology, cloud, and licensing
                        subject areas, to give
                        the best possible advice and practical methods of engagement. Through this, we can help your
                        organization put innovation
                        into practice.</p>

                    <div class="about-inner-content">
                        <div class="icon">
                            <i class="flaticon-check"></i>
                        </div>
                        <h4>Our Mission</h4>
                        <p>To deliver State of the Art Technology Solutions to our Customers through disruptive
                            Innovation and to provide a
                            Progressive Platform to our Employees to Achieve Excellence in this quickly transforming
                            world.</p>
                    </div>

                    <div class="about-inner-content">
                        <div class="icon">
                            <i class="flaticon-check"></i>
                        </div>
                        <h4>Our Values</h4>
                        <p>
                            <li>Customer Centricity</li>
                            <li>Employees First</li>
                            <li>Disruptive Innovation</li>
                            <li>Responsible Corporate Citizen</li>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End About -->

<!-- Industries -->
<section class="industries-area pt-100 pb-100">
    <div class="container">
        <div class="section-title">
            <span>Industries We Work For</span>
            <h2>Helping Businesses in All Domains</h2>
            <div class="bar"></div>
        </div>

        <div class="row">
            <div class="col-lg-3 col-md-6">
                <div class="single-industries-box">
                    <i class="flaticon-digital-marketing-2"></i>
                    <h3>Logistics & Transportation</h3>
                    <a routerLink="/industries"></a>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="single-industries-box">
                    <i class="flaticon-bank"></i>
                    <h3>Banking & Finance Services</h3>
                    <a routerLink="/industries"></a>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="single-industries-box">
                    <i class="flaticon-graduation-cap"></i>
                    <h3>Education Services</h3>
                    <a routerLink="/industries"></a>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="single-industries-box">
                    <i class="flaticon-stock-market"></i>
                    <h3>Insurance</h3>
                    <a routerLink="/industries"></a>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="single-industries-box">
                    <i class="flaticon-employee"></i>
                    <h3>Cash Managements</h3>
                    <a routerLink="/industries"></a>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="single-industries-box">
                    <i class="flaticon-waiter"></i>
                    <h3>Event Managements</h3>
                    <a routerLink="/industries"></a>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="single-industries-box">
                    <i class="flaticon-stethoscope"></i>
                    <h3>Healthcare</h3>
                    <a routerLink="/industries"></a>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="single-industries-box">
                    <i class="flaticon-user"></i>
                    <h3>Social Media</h3>
                    <a routerLink="/industries"></a>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Industries -->




<!-- Team -->
<!-- <section class="team-area pt-100 pb-70">
    <div class="container">
        <div class="section-title">
            <span>Team Member</span>
            <h2>Our Expert Team</h2>
            <div class="bar"></div>
        </div>

        <div class="row">
            <div class="col-lg-3 col-md-6">
                <div class="single-team-box">
                    <div class="image">
                        <img src="assets/img/team/team-6.jpg" alt="image">

                        <ul class="social">
                            <li><a href="#" target="_blank"><i class='bx bxl-facebook'></i></a></li>
                            <li><a href="#" target="_blank"><i class='bx bxl-twitter'></i></a></li>
                            <li><a href="#" target="_blank"><i class='bx bxl-linkedin'></i></a></li>
                            <li><a href="#" target="_blank"><i class='bx bxl-instagram'></i></a></li>
                        </ul>
                    </div>

                    <div class="content">
                        <h3>Chandrakant Kshirsagar</h3>
                        <span>Co-Founder & CEO</span>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="single-team-box">
                    <div class="image">
                        <img src="assets/img/team/team-7.jpg" alt="image">

                        <ul class="social">
                            <li><a href="#" target="_blank"><i class='bx bxl-facebook'></i></a></li>
                            <li><a href="#" target="_blank"><i class='bx bxl-twitter'></i></a></li>
                            <li><a href="#" target="_blank"><i class='bx bxl-linkedin'></i></a></li>
                            <li><a href="#" target="_blank"><i class='bx bxl-instagram'></i></a></li>
                        </ul>
                    </div>

                    <div class="content">
                        <h3>Priyanka Kshirsagar</h3>
                        <span>Co-Founder & CEO</span>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="single-team-box">
                    <div class="image">
                        <img src="assets/img/team/team-8.jpg" alt="image">

                        <ul class="social">
                            <li><a href="#" target="_blank"><i class='bx bxl-facebook'></i></a></li>
                            <li><a href="#" target="_blank"><i class='bx bxl-twitter'></i></a></li>
                            <li><a href="#" target="_blank"><i class='bx bxl-linkedin'></i></a></li>
                            <li><a href="#" target="_blank"><i class='bx bxl-instagram'></i></a></li>
                        </ul>
                    </div>

                    <div class="content">
                        <h3>Kailash Dhamame</h3>
                        <span>UI Designer</span>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="single-team-box">
                    <div class="image">
                        <img src="assets/img/team/team-9.jpg" alt="image">

                        <ul class="social">
                            <li><a href="#" target="_blank"><i class='bx bxl-facebook'></i></a></li>
                            <li><a href="#" target="_blank"><i class='bx bxl-twitter'></i></a></li>
                            <li><a href="#" target="_blank"><i class='bx bxl-linkedin'></i></a></li>
                            <li><a href="#" target="_blank"><i class='bx bxl-instagram'></i></a></li>
                        </ul>
                    </div>

                    <div class="content">
                        <h3>Carl Anderson</h3>
                        <span>Android/IOS Developer</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section> -->
<!-- End Team -->

<!-- Testimonials -->
<section class="testimonial-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-6 offset-lg-6">
                <div class="testimonial-content">
                    <span>Testimonials</span>
                    <h2>Our Client’s Review</h2>
                    <div class="bar"></div>
                </div>
            </div>
        </div>

        <div class="testimonial-slider owl-carousel owl-theme">
            <div class="testimonial-item">
                <div class="row">
                    <div class="col-lg-6 col-md-12">
                        <div class="testimonial-image"></div>
                    </div>

                    <div class="col-lg-6 col-md-12">
                        <div class="testimonial-inner-content">
                            <div class="icon">
                                <i class="flaticon-left-quotes-sign"></i>
                            </div>
                            <p>MicroSync Technologies is incredibly collaborative and easy to work with. MicroSync
                                Technologies
                                Technologies delivers high-quality work that meets the client's expectations and
                                requirements. The team excels at
                                project management by employing an agile methodology, communicating well, and executing
                                their tasks quickly.</p>
                            <div class="info-text">
                                <h4>Awasthi Rane</h4>
                                <span>BitFlyer Technologies</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="testimonial-item">
                <div class="row">
                    <div class="col-lg-6 col-md-12">
                        <div class="testimonial-image image-two"></div>
                    </div>

                    <div class="col-lg-6 col-md-12">
                        <div class="testimonial-inner-content">
                            <div class="icon">
                                <i class="flaticon-left-quotes-sign"></i>
                            </div>
                            <p>They understand our mission and want to help us succeed. MicroSync Technologies work has
                                improved the client’s operations, and their tool has been praised for its high quality.
                                They are communicative, perceptive, and flexible — they’ve pivoted their approach after
                                initial difficulties. A true
                                partner, they’re interested in the project’s long-term success.</p>
                            <div class="info-text">
                                <h4>Ajit Singh</h4>
                                <span>E-Dreams Technologies</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    </div>
</section>
<!-- End Testimonials -->